import React from 'react'
import PropTypes from 'prop-types'

export const CardCompanies = ({className, width, height, company, programFidelity, onClick, dataAction}) => {
  return (
    <div 
      className={`card-companies ${className}`}
      style={{width: width, height: height}}
      onClick={() => onClick()}
      data-action={dataAction}>
      <span className='card-companies--company'>{company}</span>
      <span className='card-companies--fidelity-program'>{programFidelity}</span>
    </div>
  )
}

CardCompanies.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  company: PropTypes.string.isRequired,
  programFidelity: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  dataAction: PropTypes.string
}

CardCompanies.defaultProps = {
  className: "",
  width: '100%',
  height: '100px'
}

export default CardCompanies
